import { Injectable } from '@angular/core';
import {
  ACCEPT_VERSION_HEADER,
  AuthHttpService,
} from '../auth-data/auth-http.service';
import {
  OfferTypesEnum,
  PRICING_API_ACCEPT_VERSION,
} from './pricing-data.data';
import { Observable } from 'rxjs';
import { IResponseInfo } from 'i2g-ng-utils';

@Injectable()
export class PricingDataService {
  protected inputHeaders: any = {
    [ACCEPT_VERSION_HEADER]: PRICING_API_ACCEPT_VERSION,
  };

  constructor(private _authHttpService: AuthHttpService) {}

  fetchOffer(offerType: OfferTypesEnum): Observable<IResponseInfo> {
    return this._authHttpService.get(
      `/pricing/offers/${offerType}`,
      {},
      this.inputHeaders
    );
  }
}
